import { Box, Typography } from "@mui/material"

const PageNotFound = () => {
    return (
        <Box width="100%" align="center">
            <Typography fontSize="18rem" fontWeight="bold">404</Typography>
            <Typography fontSize="5rem">Not Found</Typography>
            <Typography fontSize="2rem">The resource requested could not be found on the server!</Typography>
        </Box>
    );
};

export default PageNotFound;